<div class="container">
  <mat-card class="center-card">
    <mat-card-title>Join!</mat-card-title>
    <mat-card-content>
      <p>One of us</p>
      <button class="login-button" color="primary" mat-flat-button (click)="auth.loginWithRedirect()">Log in</button>
    </mat-card-content>
  </mat-card>
</div>
